import { abyssColors } from '@/theme/colors';
import { styled as muiStyled } from '@mui/material/styles';
import { Stack, Box } from '@mui/material';

export const Layout = muiStyled(Box)({
  width: '100%',
  minHeight: '100vh',
  maxHeight: '100vh',
  position: 'relative',
  padding: '3.2rem',
  overflowY: 'auto',
});

export const Container = muiStyled(Stack)({
  height: '100%',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
});

export const ImportPanel = muiStyled(Stack)<{ verticalOffset?: number }>(
  ({ verticalOffset = 0 }) => ({
    width: '100%',
    gap: '2.4rem',
    minWidth: '94.8rem',
    marginTop: `calc(-${verticalOffset}px - 2.4rem)`,
    padding: '3.2rem',
  })
);

export const PanelHeader = muiStyled(Stack)({
  alignItems: 'center',
  gap: '1.2rem',
});

export const ImportTypeSelector = muiStyled(Stack)({
  width: '100%',
  height: '46.8rem',
  borderRadius: '0.8rem',
  backgroundColor: abyssColors.primary[50],
  padding: '4.8rem',
  paddingTop: '4.6rem',
});
